/*
 * Copyright © 2021 Firecrest Clinical, Ltd.
 * All rights reserved.
*/

import {EditorState} from 'prosemirror-state';
import {Command} from 'prosemirror-commands';
import {Dispatch} from '../src/lib/commands/types';

const isImageSelected = (): Command => {
    return (state: EditorState, dispatch?: Dispatch): boolean => {
        const {selection, doc} = state;

        const {from, to, empty} = selection;

        if (!empty && (from + 1 === to)) {
            const node = doc.nodeAt(from);
            if (node?.isAtom && !node.isText && node.isLeaf) {
                // An atomic node (e.g. Image) is selected.
                return true;
            }
        }

        return false;
    };
};

export default isImageSelected;
